import type { MessengerPreChatViewSettings } from '@widgets/messenger/types'
import { useWidgetChannels } from '@widgets/messenger/compositions/useWidgetChannels'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const useWidgetPreChatViewSettings = () => {
  const { widgetSettings } = useWidgetStore()
  const { channelMap } = useWidgetChannels()

  return computed<MessengerPreChatViewSettings>(() => {
    const { fieldLabel: messageLabel, buttonLabel: messageButtonText } =
      widgetSettings.value.channels[WebWidgetChannelType.CHAT].uiSettings
    const {
      title: introductionTitle,
      buttonText: introductionButtonText,
      fieldSorting,
    } = widgetSettings.value.channels[WebWidgetChannelType.CHAT].uiSettings.preChatScreen

    return {
      channel: channelMap.value[WebWidgetChannelType.CHAT],
      messageLabel,
      messageButtonText,
      introductionTitle,
      introductionButtonText,
      formFields: fieldSorting.map((fieldName, index) => {
        const isRequired =
          fieldName === 'name' ? widgetSettings.value.channels[WebWidgetChannelType.CHAT].fieldSettings.name : true
        return {
          name: fieldName,
          order: index + 1,
          isRequired,
        }
      }),
    } satisfies MessengerPreChatViewSettings
  })
}
